export default __webpack_public_path__ + "static/media/Shin-pads of the Black Pharaoh.b3f15ce8.jpg";